import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Component({
  selector: 'app-browser-support-message',
  templateUrl: './browser-support-message.component.html',
  styleUrls: ['./browser-support-message.component.scss']
})
export class BrowserSupportMessageComponent implements OnInit {
  deviceInfo: DeviceInfo;
  version:any;
  broswer:any;

  constructor( private deviceDetectorService: DeviceDetectorService) { }

  ngOnInit(): void {
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
    this.version = this.deviceInfo.browser_version;
    this.broswer = this.deviceInfo.browser;

  }

}
